import { Benchmark } from "./types/benchmark.type";

export interface GetVideoBenchmarkReq {
  projectId: string;
  studyId: string;
}

// TODO(DFP-1117): Replace this mock with a real call to api-studio once the benchmark endpoint exists.
const MOCK_VIDEO_BENCHMARK: Benchmark = {
  id: "social-facebook",
  name: "Social Facebook",
  videoCount: 1201,
  scoreRangeMin: 64,
  scoreRangeMax: 85,
};

/*
 * getVideoBenchmark endpoint
 *
 * Mocked until the api-studio benchmark endpoint is ready. Returns the benchmark applied
 * to a video study's Attention scores, for comparison against each asset's own score.
 */
export const getVideoBenchmark = async (req: GetVideoBenchmarkReq): Promise<Benchmark> => {
  void req; // projectId/studyId will become URL params once this calls the real endpoint
  return Promise.resolve(MOCK_VIDEO_BENCHMARK);
};
